import {BufferWriter, Writer} from "protobufjs";

import {CustomerBlackList} from "../../../domain/model/customer_black_list";
import {ICustomerBlackListRepository} from "../../../domain/repository/customer_black_list_repository"

import {entity, api} from "../rpc/api";
import {getToken} from "./bind_token";
import {IApiClient} from "../client";

import CustomerID = entity.CustomerID;
import CustomerBlackListFromAPI = entity.CustomerBlackList;
import UpdateCustomerBlackListRequest = api.UpdateCustomerBlackListRequest;

class CustomerBlackListAPI implements ICustomerBlackListRepository {

    constructor(readonly apiClient: IApiClient) {}

    public get(customerId: string): Promise<CustomerBlackList>{
        return new Promise<CustomerBlackList>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: CustomerID = new CustomerID();
                    req.id = customerId;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.CustomerBlackListService/Get", token, CustomerID.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void =>{
                    const res: CustomerBlackListFromAPI = CustomerBlackListFromAPI.decode(binary);
                    const item: CustomerBlackList = CustomerBlackList.from(res);
                    resolve(item);
                }).catch((error: Error) => {
                    reject(error);
            })
        })
    }

    public update(domains: string[]): Promise<void>{
        return new Promise<void>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: UpdateCustomerBlackListRequest = new UpdateCustomerBlackListRequest();
                    req.domains = domains;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.CustomerBlackListService/Update", token, UpdateCustomerBlackListRequest.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    resolve();
                }).catch((error: Error) => {
                    reject(error);
                });
        })
    }

}

const createCustomerBlackListAPI = (apiClient: IApiClient): ICustomerBlackListRepository =>{
    return new CustomerBlackListAPI(apiClient);
};

export {createCustomerBlackListAPI};


// WEBPACK FOOTER //
// ./src/infra/api/service/customer_black_list_api.ts